import { cx, css } from '@emotion/css';
import React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import '@grafana/data';
import { useTheme2, InlineField } from '@grafana/ui';
import { OperationEditorBody } from './OperationEditorBody.js';

function OperationEditor({
  operation,
  index,
  onRemove,
  onToggle,
  onChange,
  onRunQuery,
  queryModeller,
  query,
  datasource,
  flash,
  highlight,
  timeRange,
  isConflictingOperation
}) {
  const def = queryModeller.getOperationDefinition(operation.id);
  const theme = useTheme2();
  const isConflicting = isConflictingOperation ? isConflictingOperation(operation, query.operations) : false;
  const styles = getStyles(theme);
  if (!def) {
    return /* @__PURE__ */ React.createElement("span", null, "Operation ", operation.id, " not found");
  }
  const isInvalid = (isDragging) => {
    if (isDragging) {
      return undefined;
    }
    return isConflicting ? true : undefined;
  };
  return /* @__PURE__ */ React.createElement(Draggable, { draggableId: `operation-${index}`, index }, (provided, snapshot) => /* @__PURE__ */ React.createElement(
    InlineField,
    {
      error: "You have conflicting label filters",
      invalid: isInvalid(snapshot.isDragging),
      className: cx(styles.error, styles.cardWrapper)
    },
    /* @__PURE__ */ React.createElement(
      OperationEditorBody,
      {
        provided,
        flash,
        highlight,
        isConflicting,
        index,
        operation,
        definition: def,
        onChange,
        onRemove,
        onToggle,
        queryModeller,
        query,
        timeRange,
        onRunQuery,
        datasource
      }
    )
  ));
}
const getStyles = (theme, isConflicting) => {
  return {
    cardWrapper: css({
      alignItems: "stretch"
    }),
    error: css({
      marginBottom: theme.spacing(1)
    })
  };
};

export { OperationEditor };
//# sourceMappingURL=OperationEditor.js.map
